class MiniCart extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
    this.isLoaded = false;
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    this.details = this.closest('details') || document.querySelector('.cart-drawer-container');

    // 1. Intersection Observer (fallback for desktop/browsers supporting it inside details)
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this));
      this.observer.observe(this);
    }

    // 2. Direct interaction triggers on cart buttons (click, touchstart, pointerdown)
    const cartButtons = document.querySelectorAll('.cart-drawer-container summary, .header__icon--cart, [href="/cart"], .datalayer__cart--mobile_icon');
    cartButtons.forEach(btn => {
      ['click', 'touchstart', 'pointerdown', 'mouseenter'].forEach(eventType => {
        btn.addEventListener(eventType, () => {
          this.loadContent();
        }, { passive: true });
      });
    });

    // 3. Details element 'toggle' event (fires whenever <details> open attribute changes)
    if (this.details) {
      this.details.addEventListener('toggle', () => {
        if (this.details.hasAttribute('open')) {
          this.loadContent();
        }
      });
    }

    // 4. Listen to global open events
    document.addEventListener('cartdrawer:open', () => this.loadContent());

    // 5. Preload on idle or short timeout for instantaneous cart drawer opening on mobile
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(() => this.loadContent(true), { timeout: 3000 });
    } else {
      setTimeout(() => this.loadContent(true), 1500);
    }
  }

  handleIntersection(entries, observer) {
    if (!entries[0] || !entries[0].isIntersecting) return;
    if (this.observer) {
      this.observer.unobserve(this);
    }
    this.loadContent();
  }

  loadContent(isPreload = false) {
    if (this.isLoaded || this.isLoading) return;
    this.isLoading = true;

    if (typeof window.updateViewportHeight === 'function') {
      window.updateViewportHeight();
    }

    const baseSectionUrl = this.dataset.url || (window.routes ? window.routes.root : '/') + '?section_id=mini-cart';
    const fetchUrl = baseSectionUrl + (baseSectionUrl.indexOf('?') !== -1 ? '&' : '?') + 't=' + Date.now();

    fetch(fetchUrl)
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then(html => {
        const target = document.getElementById('mini-cart');
        const content = this.getSectionInnerHTML(html, '.shopify-section');
        if (target && content) {
          target.innerHTML = content;
        }
        this.isLoaded = true;
        this.isLoading = false;

        if (typeof window.updateViewportHeight === 'function') {
          window.updateViewportHeight();
        }
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error('Failed to load mini-cart:', e);
        this.isLoading = false;
      });
  }

  open() {
    this.loadContent();

    const detailsElement = this.drawer ? this.drawer.querySelector('details') : document.querySelector('.cart-drawer-container');
    if (detailsElement && detailsElement.hasAttribute('open')) {
      return;
    }
    
    if (typeof window.updateViewportHeight === 'function') {
      window.updateViewportHeight();
    }

    if (this.drawer && typeof this.drawer.openMenuDrawer === 'function') {
      this.drawer.openMenuDrawer();
    }
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        const content = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        if (content) {
          document.getElementById(section.id).innerHTML = content;
        }
      }
    }));
    this.isLoaded = true;
    this.isLoading = false;

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const el = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
    return el ? el.innerHTML : '';
  }
}

customElements.define('mini-cart', MiniCart);
